var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline:natrue-ecology-recycle-1-sign-environment-protect-save-arrows",
    clipPath: "url(#clip0_3230_1184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5728 35.0601V41.9172C20.5639 42.1749 20.4552 42.4191 20.2697 42.5982C20.0842 42.7773 19.8363 42.8774 19.5785 42.8772H12.3785C11.1946 42.6778 10.1229 42.0567 9.36133 41.1286",
    stroke: "#111111",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.4863 22.3401L40.5606 18.9115C40.674 18.8614 40.7966 18.8356 40.9206 18.8356C41.0445 18.8356 41.1671 18.8614 41.2806 18.9115C41.413 18.927 41.5403 18.972 41.653 19.0432C41.7658 19.1144 41.8611 19.21 41.932 19.3229L45.8748 25.2201C46.1104 25.6942 46.233 26.2164 46.233 26.7458C46.233 27.2752 46.1104 27.7974 45.8748 28.2715M9.36056 41.1629C9.36056 41.1629 5.62342 37.9058 14.2977 29.2315H18.172L12.3777 19.6658H1.71484L4.62913 23.4029C4.62913 23.4029 2.67484 23.7458 2.67484 26.4544C3.69989 31.8198 5.9921 36.8627 9.36056 41.1629Z",
    stroke: "#111111",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.9155 15.1743L10.2869 13.0486C10.0586 12.9306 9.88272 12.7315 9.79389 12.4904C9.70505 12.2493 9.70969 11.9836 9.80689 11.7457L13.7155 3.92859C13.9766 3.46578 14.3417 3.06999 14.782 2.77248C15.2223 2.47498 15.7258 2.28389 16.2526 2.21431M16.2526 2.21431C16.2526 2.21431 20.4697 2.21431 25.8183 12.5L23.0412 15.9286H34.5612L38.6412 5.16288L33.8412 6.63716C33.7714 5.89326 33.502 5.182 33.0615 4.57851C32.6209 3.97503 32.0256 3.50173 31.3383 3.20859C28.9751 2.42626 26.4873 2.08913 24.0012 2.21431H16.2526ZM46.0126 27.9286C46.0126 27.9286 44.9155 32.3857 33.5669 31.3572V28.3743L26.9155 37.0829L33.224 46.7857L33.5669 42.2257C33.5669 42.2257 34.8355 43.7686 36.9955 42.2257C40.618 37.8781 43.65 33.0708 46.0126 27.9286Z",
    stroke: "#111111",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3230_1184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.8908c14a278ed8a750403a3db8f425ea.svg";
export { ForwardRef as ReactComponent };